import { gql } from '@apollo/client';

import client from '../../../config/apolloClient';
import URL from '../../../constants/ApiEndPoints';

const GET_CANCEL_SKU_LIST = gql`
  query getCancelSkuList($path: String!) {
    getCancelSkuList @rest(method: "GET", path: $path, endpoint: "pheonix") {
        data
      }
  }
`;

const getCancelSkuListService = (supplyOrderAliasId: string) => {
  const url = URL.getCancelSkuList.replace('{supplyOrderAliasId}', supplyOrderAliasId);
  return client.query({ query: GET_CANCEL_SKU_LIST, variables: { path: url } });
};

export default getCancelSkuListService;
